import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import SubmissionPublicationAppService from '../../../../application/platform/sep/subimission-publication/subimission-publication-app-service';
import { IUserSendSubimissonPublicationResponse } from '../../../../model/sep/submission-publications/response/user-send-submission-publication-response';
import { ACTION_TYPES, useSubmissionPublicationSearchDispatch, useSubmissionPublicationSearchState } from "./submission-publication-search-context";
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useSubmissionPublicationSearchController = () => {
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = useSubmissionPublicationSearchDispatch();
    const state = useSubmissionPublicationSearchState();
    const { submissionPublicationId } = useParams();

    useEffect(() => {
        loadInitialData();
    }, []);

    async function loadInitialData() {
        try {
            showLoading({ open: true });

            const users = await SubmissionPublicationAppService.findUsersSend({} as IUserSendSubimissonPublicationResponse);
            dispatch({ type: ACTION_TYPES.setUsers, payload: users });

            const status = await SubmissionPublicationAppService.listStatus();
            dispatch({ type: ACTION_TYPES.setStatus, payload: status });

            if (submissionPublicationId !== undefined) {
                dispatch({
                    type: ACTION_TYPES.setSubmissionPublicationId,
                    payload: Number(submissionPublicationId)
                });
            }

            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar os filtros de pesquisa',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            showLoading({ open: false });
        }
    }

    function handleOnChange(e: any) {
        let statusId = state.parameters.statusId;
        let types = state.parameters.types;
        let id = state.parameters.id;
        let userSenderId = state.parameters.userSenderId;
        let clientId = state.parameters.clientId;

        if (e.target.name === "input-id") {
            id = e.target.value;
        }
        if (e.target.name === "select-type") {
            types = e.target.value;
        }
        if (e.target.name === "select-status") {
            statusId = e.target.value;
        }
        if (e.target.name === "select-user-id") {
            userSenderId = e.target.value;
        }
        if (e.target.name === "select-client") {
            clientId = e.target.value;
        }

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { statusId, types, id, userSenderId, clientId, page: 0 }
        });
    }

    function handleStartDateChange(newValue: any) {
        const newDate = newValue as moment.Moment;

        dispatch({
            type: ACTION_TYPES.setDatesParameters,
            payload: {
                starDatePicker: newDate,
                endDatePicker: state.datesParameters.endDatePicker
            }
        });

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { startDate: newDate.format("YYYY-MM-DD"), page: 0 }
        });
    }

    function handleEndDateChange(newValue: any) {
        const newDate = newValue as moment.Moment;

        dispatch({
            type: ACTION_TYPES.setDatesParameters,
            payload: {
                starDatePicker: state.datesParameters.starDatePicker,
                endDatePicker: newDate
            }
        });

        dispatch({
            type: ACTION_TYPES.updateParameter,
            payload: { endDate: newDate.format("YYYY-MM-DD"), page: 0 }
        });
    }

    return {
        handleOnChange,
        handleStartDateChange,
        handleEndDateChange
    };
}
